// @flow

import { type FeatureName, type Feature } from './types';

export function hasFeature(allFeatures: ImmutableArray<Feature>, wanted: FeatureName): bool {
  return allFeatures.some(feature => feature.name === wanted);
}
